import { useEffect, useRef, useState } from "react";
import { claimPlayback, releasePlayback, stopLumiAudio } from "@/lib/lumiAudio";

// Plain Privacy-Enhanced YouTube embed for Kids Corner: no IFrame Player API script, autoplay off,
// no YouTube cookies until the child presses play. A click inside the player (window blur while the
// iframe holds focus) stops Lumi's voice; if other Lumi media starts, the embed is reset instead of paused.
export const NO_COOKIE_HOST = "https://www.youtube-nocookie.com";

export const NoCookieYouTube = ({ videoId, title, nonce = 0, captions = false, testId }) => {
  const iframeRef = useRef(null);
  const [gen, setGen] = useState(0);
  const stop = useRef(() => setGen((g) => g + 1)).current;

  useEffect(() => {
    const onBlur = () => {
      if (document.activeElement === iframeRef.current) { stopLumiAudio(); claimPlayback(stop); }
    };
    window.addEventListener("blur", onBlur);
    return () => { window.removeEventListener("blur", onBlur); releasePlayback(stop); };
  }, [stop]);

  const params = new URLSearchParams({ autoplay: "0", rel: "0", modestbranding: "1", playsinline: "1" });
  if (captions) { params.set("cc_load_policy", "1"); params.set("cc_lang_pref", "en"); }

  return (
    <iframe
      key={`${nonce}-${gen}`}
      ref={iframeRef}
      src={`${NO_COOKIE_HOST}/embed/${videoId}?${params.toString()}`}
      title={title}
      className="absolute inset-0 w-full h-full"
      allow="encrypted-media; picture-in-picture; fullscreen"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
      data-testid={testId}
    />
  );
};
